<template>
    <div>
        <h1 style="font-size: 24px; color: black;">常量规则配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showVersionFormDialog">添加版本</el-button>
                <el-button type="primary" @click="showAddRuleConfigFormDialog('添加配置')">添加配置</el-button>
            </el-col>
        </el-row>
       <div style="margin-bottom: 10px;">
        <el-tabs type="border-card" v-model="versionCode"  @tab-click="changeIndex" >
            <el-tab-pane v-for="version in versionList"  :name="version.version" :key="version.id" :label="version.version">
            </el-tab-pane>
            <h1>
                <el-table border :data="list">
                    <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                    <el-table-column prop="key" label="Key值" align="center"></el-table-column>
                    <el-table-column prop="value" label="Value值" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="version" label="版本" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="notes" label="备注" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column  label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showAddRuleConfigFormDialog('编辑配置',scope.row,scope.$index)">编辑</el-button>
                            <el-button type="text" @click="removeRuleConfig(scope.row.id)">删除</el-button>
                        </template >
                    </el-table-column>
                </el-table>
            </h1>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,30]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </el-tabs>
       </div>

        <el-dialog :title="dialogRuleConfigTitle" center :visible.sync="dialogRuleConfigVisible" width="800px">
            <el-form :model="addRuleConfigForm">
                <el-form-item label="规则Key值 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addRuleConfigForm.key" ></el-input>
                </el-form-item>
                <el-form-item label="规则Value值 :" :label-width="labelWidth" >
                    <el-input  type="textarea" v-model="addRuleConfigForm.value"  autosize></el-input>
                </el-form-item>
                <el-form-item label="备注 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addRuleConfigForm.notes"  ></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmRuleConfigForm" >提 交</el-button>
                <el-button type="info" @click="dialogRuleConfigVisible=false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加版本" center :visible.sync="dialogVersionVisible" width="800px" >
            <el-form :model="addVersionForm">
                <el-form-item label="版本 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addVersionForm.version"  ></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmVersionForm" >提 交</el-button>
                <el-button type="info" @click="dialogVersionVisible=false">取 消</el-button>
            </div>
            <div style="padding-top: 30px">
                <el-table border :data="versionList">
                    <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                    <el-table-column prop="version" label="版本" align="center" ></el-table-column>
                    <el-table-column  label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="removeVersion(scope.row.id)">删除</el-button>
                        </template >
                    </el-table-column>
                </el-table>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import {
        deleteRuleConfig,
        deleteVersion,
        saveRuleConfig,
        saveVersion,
        versionList,
        searchRuleConfig
    } from '@/http/iosApi';
    import store from '@/store'
    export default {
        name: "RuleConfig",
        data(){
            return{
                versionCode:store.state.newProjectVersion.selectedVersion,
                versionList:[],
                dialogRuleConfigVisible: false,
                dialogVersionVisible :false ,
                addVersionForm:{},
                dialogRuleConfigTitle:'',
                labelWidth: '110px',
                list:[],
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                addRuleConfigForm: {
                    id: 0,
                    key: '',
                    value: '',
                    notes: '',
                    version:'',
                },
                queryData:{},
            }
        },
        methods:{
            removeRuleConfig(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRuleConfig(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search();
                        }
                    });
                }).catch(() => {
                })
            },
            removeVersion(id){
                this.$confirm('此操作将永久删除版本及其配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteVersion(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.version();
                            this.search();
                        }
                    });
                }).catch(() => {
                })
            },
            showAddRuleConfigFormDialog(_title, _data,index){
                this.dialogRuleConfigVisible = true;
                this.dialogRuleConfigTitle = _title;
                this.addRuleConfigForm={
                    id: 0,
                    key: '',
                    value: '',
                    notes: '',
                    version:this.versionCode
                };
                if (_data) {
                    //刷新数据逻辑 
                    this.search();
                    setTimeout(()=>{
                        _data= this.list[index];
                        // console.log(temp)
                        this.addRuleConfigForm = {
                        id: _data.id,
                        key: _data.key,
                        value:_data.value,
                        notes:_data.notes,
                        version:_data.version
                    }
                    },1000); 
                }
            },
            confirmRuleConfigForm(){
                const param=/^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/;
                const  isVersion = param.test(this.addRuleConfigForm.version);
                let _message = '';
                if(this.addRuleConfigForm.key===''){
                    _message = '请输入kye值'
                }else if (!isVersion){
                    _message = '请输入正确版本号 x.x.x'
                }else if (this.addRuleConfigForm.notes==='' ){
                    _message = '请填写备注，以防忘记配置内容'
                }
                if(_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveRuleConfig(this.addRuleConfigForm).then(resp=>{
                    if(resp.data.status===0){
                       this.search();
                        this.dialogRuleConfigVisible=false;
                    }
                });
            },
            search(){
                this.queryData.version = this.versionCode;
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchRuleConfig(this.queryData).then(resp=>{
                    this.list= resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },

            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },

            showVersionFormDialog(){
                this.dialogVersionVisible = true;
                this.addVersionForm={
                    id: 0,
                    version:''
                };
            },
            confirmVersionForm(){
                const param=/^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/;
                const  isVersion = param.test(this.addVersionForm.version);
                let _message = '';
                if (!isVersion){
                    _message = '请输入正确版本号 x.x.x'
                }
                if(_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveVersion(this.addVersionForm).then(resp=>{
                    if(resp.data.status===0){
                        this.version();
                        this.search();
                        this.dialogVersionVisible=false;
                    }
                });
            },

            changeIndex: function(tab){
                this.$store.commit('changeSelectedVersionType', tab.name);
                this.versionCode  = tab.name;
                this.addRuleConfigForm.version= tab.name;
                this.page.page = 1;
                this.search();
            },
            version(){
                versionList().then(resp=>{
                    this.versionList = resp.data.info;
                });
            }

        },
        created() {
            this.versionCode=store.state.newProjectVersion.selectedVersion,
            this.search();
            this.version();
        }
    }
</script>

<style scoped>

</style>
